<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Manage Order items </h5>
                </div>
                <div class="card-body">
                    <div class="custom-datatable">
                        <input type='text' class="filter-ngx form-control" placeholder='Search...'
                            (keyup)='updateFilter($event)' />
                        <ngx-datatable class="bootstrap" [rows]="orderItem" [columnMode]="'force'" [headerHeight]="50"
                            [footerHeight]="50" [rowHeight]="'auto'" [limit]="5">
                            <ngx-datatable-column prop="productCode"></ngx-datatable-column>
                            <ngx-datatable-column name="Category"></ngx-datatable-column>
                            <ngx-datatable-column name="Variant Title"></ngx-datatable-column>
                            <ngx-datatable-column prop="quantity"></ngx-datatable-column>
                            <ngx-datatable-column prop="size"></ngx-datatable-column>
                            <ngx-datatable-column prop="color"></ngx-datatable-column>
                            <ngx-datatable-column prop="unitPrice"></ngx-datatable-column>
                        </ngx-datatable> 
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->